import {InjectionToken} from '@angular/core';
import {J4BreadcrumbsItem, J4TopBarConfig} from 'shared/interfaces/j4-topbar';

export const TRANSACTION_EXPLORER_BASE_URL = new InjectionToken<string>('TRANSACTION_EXPLORER_BASE_URL');

/**
 * Top bar configuration for Alerts Management pages.
 * Only breadcrumbs are shown; all case/workflow features are disabled.
 */
export const j4AlertsTopBarConfig: J4TopBarConfig = {
  showBreadcrumbs: true,
  showCaseStatus: false,
  showUserGroupList: false,
  showLeftMiniButton: false,
  showRightMiniButton: false,
  showStateLabel: false,
  showCurrentAssignee: false,
  showDueDate: false,
  showRuleLabelList: false,
  showPrimaryButton: false,
  showSecondaryButton: false
};

/**
 * Breadcrumb icon — green document SVG (same style as kyx-reporting).
 */

export const j4AlertsBreadcrumbsIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="21" viewBox="0 0 18 21"><path d="M8.61852 21.0076C9.80356 21.0076 10.7731 20.038 10.7731 18.853H6.46389C6.46389 20.038 7.4227 21.0076 8.61852 21.0076ZM15.0824 14.5437V9.15717C15.0824 5.84982 13.3156 3.08112 10.2345 2.34855V1.61597C10.2345 0.721801 9.51269 0 8.61852 0C7.72434 0 7.00254 0.721801 7.00254 1.61597V2.34855C3.91065 3.08112 2.15463 5.83905 2.15463 9.15717V14.5437L0 16.6984V17.7757H17.237V16.6984L15.0824 14.5437Z" fill="#989eac"/></svg>`;

/**
 * Breadcrumbs for the Alerts list page.
 */
export const j4AlertsBreadcrumbsItem: J4BreadcrumbsItem[] = [{label: 'Alerts Management', url: '/'}];

export const ALERTS_ARROW_ICON_SVG = `<svg fill="none" height="9" viewBox="0 0 6 9" width="6" xmlns="http://www.w3.org/2000/svg"><path d="M0.750137 0.532822C0.457637 0.825322 0.457637 1.29782 0.750137 1.59032L3.66014 4.50032L0.750137 7.41032C0.457637 7.70282 0.457637 8.17532 0.750137 8.46782C1.04264 8.76032 1.51514 8.76032 1.80764 8.46782L5.25014 5.02532C5.54264 4.73282 5.54264 4.26032 5.25014 3.96782L1.80764 0.525322C1.52264 0.240322 1.04264 0.240322 0.750137 0.532822Z" fill="#8993A6"/></svg>`;

export const ALERTS_TOUR_CURSOR_ICON_SVG = `<svg class="tour-click-cursor__icon" width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L1 17L5.5 13L9.5 21L12.5 19.5L8.5 11.5L14 11.5L1 1Z" fill="white" stroke="#333" stroke-width="1.5" stroke-linejoin="round"/></svg>`;
